/**
 * View component for /sites
 *
 * Generic site list view. Defaults to 'all' with:
 * this.props.dispatch(siteActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as siteActions from '../siteActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as studyUserActions from '../../studyUser/studyUserActions';

// import global components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';
import Pagination from "../../../global/components/helpers/Pagination.js.jsx";
import { SearchInput } from '../../../global/components/forms';

// import utilities
import filterUtils from '../../../global/utils/filterUtils';

// import site components
import SiteListItem from '../components/SiteListItem.js.jsx';

// import site css modules
import siteStyles from '../siteModuleStyles.css';

class AdminStudySiteList extends Base {
  constructor(props) {
    super(props);
    this.state = {
      perPage: 50
      , queryText: this.props.query || ''
    };
    this._bind(
      '_handleQuery'
      , '_handleSetPagination'
      , '_handleSort'
      , '_resetPagination'
      , '_setPerPage'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;

    // get study and sponsr
    dispatch(studyActions.fetchSingleIfNeeded(match.params.studyId)).then((action) => {
      console.log(action);
      dispatch(sponsorActions.fetchSingleIfNeeded(action.item._organization));
    })

    // get sites and study users
    dispatch(siteActions.fetchListIfNeeded('_group', match.params.studyId));
    dispatch(studyUserActions.fetchListIfNeeded('_group', match.params.studyId));

    // dispatch(siteActions.fetchListIfNeeded()).then((json) => {
    //   let sponsorIds = json.list.map(site => site._organization);
    //   let studyIds = json.list.map(site => site._group);
    //   dispatch(sponsorActions.fetchListIfNeeded("_id", sponsorIds));
    //   dispatch(studyActions.fetchListIfNeeded("_id", studyIds));
    // });
    // dispatch(siteActions.setFilter({query: '', sortBy: 'name'}));
    // dispatch(siteActions.setPagination({page: 1, per: 50}));

    // for sorting, searching, and pagination
    dispatch(siteActions.setFilter({query: '', sortBy: 'name'}, '_group', match.params.studyId));
    dispatch(siteActions.setPagination({page: 1, per: 50}, '_group', match.params.studyId));
  }

  _handleSort(sortBy) {
    const { dispatch, match, siteList } = this.props;
    let newFilter = siteList.filter;
    if(siteList.filter.sortBy && siteList.filter.sortBy.indexOf("-") < 0) {
      sortBy = "-" + sortBy;
    } else {
      sortBy = sortBy.substring(0)
    }
    newFilter.sortBy = sortBy;
    dispatch(siteActions.setFilter(newFilter, '_group', match.params.studyId));
  }

  _resetPagination() {
    const { dispatch, match } = this.props;
    dispatch(siteActions.setPagination({
      page: 1,
      per: parseInt(this.state.perPage)
    }, '_group', match.params.studyId));
  }

  _setPerPage(per) {
    const { dispatch, match, siteList } = this.props;
    let newPagination = siteList.pagination;
    newPagination.per = parseInt(per);
    newPagination.page = 1;
    dispatch(siteActions.setPagination(newPagination, '_group', match.params.studyId));
    this.setState({perPage: per});
  }

  _handleSetPagination(newPagination) {
    const { dispatch, match } = this.props;
    dispatch(siteActions.setPagination(newPagination, '_group', match.params.studyId));
  }

  _handleQuery(e) {
    const { dispatch, match, siteList } = this.props;
    // always defaulting the page to page 1 so we can see our results
    let pagination = {};
    pagination.page = 1;
    pagination.per = siteList.pagination.per;
    this._handleSetPagination(pagination);
    // continue query logic
    dispatch(siteActions.setFilter({
      query: e.target.value.toLowerCase()
      , sortBy: siteList.filter.sortBy
    }, '_group', match.params.studyId));
  }

  render() {
    const {
      location
      , match
      , paginatedList
      , siteList
      , siteStore
      , sortedList
      , sponsorStore
      , studyStore
      , studyUserStore
    } = this.props;

    const selectedStudy = studyStore.selected.getItem();
    const selectedSponsor = sponsorStore.selected.getItem();
    // const siteListItems = siteStore.util.getList('_group', match.params.studyId);
    const studyUserItems = studyUserStore.util.getList('_group', match.params.studyId);

    //TODO: we need to figure out how to display users who don't have a valid site yet

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = (
      !siteList
      || !siteList.items
      || siteList.didInvalidate
      || !selectedStudy
      || !selectedSponsor
    );
    const sortedEmpty = sortedList.length === 0;

    return (
      <AuthoringLayout>
        <div className="flex">
        <Helmet
          title={"Site Study List | Pro-ficiency"}
        />
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
              { isEmpty ?
                <h1>Loading sites...</h1>
                :
                <h1> Site/Team List for {selectedStudy.name}
                  <Link className="yt-btn small u-pullRight" to={`${match.url}/new`}> New Site/Team</Link>
                </h1>
              }
              <hr/>
              { isEmpty ?
                (
                  <div className="u-centerText">
                    <div className="loading"></div>
                  </div>
                )
                :
                <div style={{ opacity: siteList.isFetching ? 0.5 : 1 }}>
                  <div className="yt-toolbar">
                    <div className="yt-tools right">
                      <div className="search">
                        <SearchInput
                          name="query"
                          value={siteList.filter.query}
                          change={this._handleQuery}
                          placeholder="Search..."
                          required={false}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="table-wrapper">
                      <table className="yt-table striped">
                        <caption>
                          { siteList.filter && siteList.filter.query && siteList.filter.query.length > 0 ?
                            <span>Filtered Sites &mdash; {sortedList.length} of {Object.keys(siteList.items).length}</span>
                            :
                            <span>All Sites &mdash; {Object.keys(siteList.items).length}</span>
                          }
                          <div className="per-page-select u-pullRight">
                            <label>Show per page: </label>
                            <select
                              name="numPerPage"
                              onChange={(e) => this._setPerPage(e.target.value)}
                              value={this.state.perPage}
                            >
                              <option value={25}> 25 </option>
                              <option value={50}> 50 </option>
                              <option value={100}> 100 </option>
                            </select>
                          </div>
                        </caption>
                        <thead>
                          <tr>
                            <th className="_20 sortable" onClick={()=> this._handleSort('name')}>
                              Name
                              {siteList.filter.sortBy === 'name' ?
                                <i className="ion ion-ios-arrow-down" />
                                : siteList.filter.sortBy === '-name' ?
                                <i className="ion ion-ios-arrow-up" />
                                : null
                              }
                            </th>
                            <th className="_20 sortable" onClick={()=> this._handleSort('number')}>
                              Number
                              {siteList.filter.sortBy === 'number' ?
                                <i className="ion ion-ios-arrow-down" />
                                : siteList.filter.sortBy === '-number' ?
                                <i className="ion ion-ios-arrow-up" />
                                : null
                              }
                            </th>
                            <th className="_20">Total Users</th>
                            <th className="_20">Sponsor</th>
                            <th className="_20">Study</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            paginatedList.map((site, i) =>
                            <SiteListItem
                              key={site._id}
                              site={site}
                              sponsor={selectedSponsor}
                              study={selectedStudy}
                              studyUsers={studyUserItems}
                            />
                          )
                        }
                      </tbody>
                    </table>
                    { sortedEmpty ?
                      null
                      :
                      <Pagination
                        pagination={siteList.pagination}
                        setPagination={this._handleSetPagination}
                        totalPages={ Math.floor(sortedList.length / siteList.pagination.per) + 1}
                      />
                    }
                  </div>
                  </div>
                </div>
              }
            </div>
          </section>
        </div>
      </AuthoringLayout>
    )
  }
}

AdminStudySiteList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store, ownProps) => {
  const sponsorStore = store.sponsor;
  const studyStore = store.study;
  const studyUserStore = store.studyUser;
  const siteStore = store.site;
  const siteList = siteStore.lists && siteStore.lists._group ? siteStore.lists._group[ownProps.match.params.studyId] : null;
  const sponsorList = sponsorStore.selected.getItem() || {};
  const studyList = studyStore.selected.getItem() || {};
  let sortedList = [];
  let paginatedList = [];
  let filteredByQuery = [];
  if (siteList) {

    const pagination = siteList.pagination;
    const filter = siteList.filter;
    const query = filter ? filter.query : '';
    const sortBy = filter ? filter.sortBy : 'name';

    // FILTER BY QUERY
    let queryTestString = ("" + query).toLowerCase().trim();
    // queryTestString = queryTestString.replace(/[^a-zA-Z0-9]/g,''); // replace all non-characters and numbers
    filteredByQuery = siteList && siteList.items ? siteList.items.filter((siteId) => {
      return filterUtils.filterSite(queryTestString, siteStore.byId[siteId], sponsorList, studyList);
    }) : []

    // SORT THE LIST
    sortedList = filteredByQuery.map((item) => {
      let newItem = siteStore.byId[item];
      return newItem;
    });
    switch(sortBy) {
      case 'name':
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['asc']);
        break;
      case '-name':
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['desc']);
        break;
      case 'number':
        sortedList = _.orderBy(sortedList, [item => item.number], ['asc']);
        break;
      case '-number':
        sortedList = _.orderBy(sortedList, [item => item.number], ['desc']);
        break;
      default:
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['asc']);
    }

    // apply pagination
    let start = pagination ? (pagination.page - 1) * pagination.per : 1;
    let end = pagination ? start + pagination.per : 0;
    paginatedList = _.slice(sortedList, start, end);

  }
  return {
    paginatedList
    , siteList
    , siteStore
    , sortedList
    , sponsorStore
    , studyStore
    , studyUserStore
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminStudySiteList)
);



// WEBPACK FOOTER //
// modules/site/views/AdminStudySiteList.js.jsx